var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Number(_vm.userId) > 0)?_c('EmployeeLink',{staticClass:"employee-selection-preview",attrs:{"user-id":_vm.userId,"fallback":_vm.name,"compact":"","icon-only":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }